import { combineReducers } from "redux";
import { userControllersState } from "./userControllersReducer";

export const userControllersReducers = combineReducers({
    userControllersState: userControllersState
});
